import { Layout } from '../components';

import { Paper } from '@mantine/core';
import { EnrollmentSearchBar } from '../enrollments/components/EnrollmentSearchBar/EnrollmentSearchBar';
import { EnrollmentSummaryList } from '../enrollments/components/EnrollmentSummaryList/EnrollmentSummaryList';
import { useEnrollments } from '../enrollments/endpoints/enrollmentsHooks';
import { useEnrollmentSearchBarParams } from '../enrollments/components/EnrollmentSearchBar/useEnrollmentSearchBarParams';
import { useThrottledValue } from '@mantine/hooks';
import { useMemo } from 'react';
import {
  ENROLLMENT_TYPE_VALUE,
  PAY_INTERVAL_VALUE,
} from '../enrollments/model';
import Fuse from 'fuse.js';

function Enrollments() {
  const { data = [], isLoading } = useEnrollments();
  const { params } = useEnrollmentSearchBarParams();

  const throttledSearchText = useThrottledValue(
    params.fuzzySearchText ?? '',
    1000,
  );

  const searchedResult = useMemo(() => {
    const enrollments = data ?? [];

    const selectedTypes =
      params.type.length === 0 ? ENROLLMENT_TYPE_VALUE : params.type;

    const selectedIntervals =
      params.interval.length === 0 ? PAY_INTERVAL_VALUE : params.interval;

    const selectedEnrollments = enrollments.filter(({ payInterval, type }) => {
      const isInType = selectedTypes.includes(type);
      const isInInterval = selectedIntervals.includes(payInterval);

      return isInInterval && isInType;
    });

    if (throttledSearchText.length < 1) {
      return selectedEnrollments;
    }

    const fuse = new Fuse(selectedEnrollments, {
      keys: ['email', 'plateNumber', 'idNumber', 'taxIdNumber'],
      threshold: 0.0, // 越小越嚴格（0~1），0.4 通常是合理模糊度
      distance: 100, // 控制字元距離容忍度
      ignoreLocation: true, // 讓 Fuse.js 不那麼在意匹配的位置
      includeScore: true,
    });

    const searched = fuse.search(throttledSearchText ?? '');

    return searched
      .sort(
        ({ score: scoreA }, { score: scoreB }) => (scoreA ?? 0) - (scoreB ?? 0),
      )
      .map(({ item }) => item);
  }, [data, params.interval, params.type, throttledSearchText]);

  return (
    <>
      <Paper shadow="xl" radius="lg" p="md">
        <Layout title="通行費申請單" className="h-full">
          <EnrollmentSearchBar />
          <EnrollmentSummaryList
            records={searchedResult}
            fetching={isLoading}
          />
        </Layout>
      </Paper>
    </>
  );
}

export default Enrollments;
